import {
  REQUEST_COMPANY_GROUPS,
  REQUEST_COMPANY_GROUPS_FAILURE,
  RESPONSE_COMPANY_GROUPS,
  SELECTED_GROUP,
  REQUEST_ADD_UNIT_GROUP,
  RESPONSE_ADD_UNIT_GROUP,
  REQUEST_ADD_UNIT_GROUP_FAILURE,
  REQUEST_DEL_UNIT_GROUP,
  RESPONSE_DEL_UNIT_GROUP,
  REQUEST_DEL_UNIT_GROUP_FAILURE,
  REQUEST_CREATE_GROUP,
  RESPONSE_CREATE_GROUP,
  REQUEST_CREATE_GROUP_FAILURE,
  REQUEST_DELETE_GROUP,
  RESPONSE_DELETE_GROUP,
  REQUEST_DELETE_GROUP_FAILURE,
} from "../actions/companyGroupsAction";

import { states } from "./queriesStates";

const initialState = {
  companyGroupsDataState: states.NOT_REQUESTED,
  addUnitGroupDataState: states.NOT_REQUESTED,
  delUnitGroupDataState: states.NOT_REQUESTED,
  createGroupDataState: states.NOT_REQUESTED,
  companyGroups: [],
  selectedGroup: null,
  errors: [],
};

const companyGroupsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_COMPANY_GROUPS:
      return Object.assign({}, state, {
        companyGroupsDataState: states.REQUEST,
      });
    case RESPONSE_COMPANY_GROUPS:
      return Object.assign({}, state, {
        companyGroupsDataState: states.READY,
        companyGroups: action.data.groups,
      });
    case REQUEST_COMPANY_GROUPS_FAILURE:
      return Object.assign({}, state, {
        companyGroupsDataState: states.FAILURE,
        errors: action.errors,
      });

    case SELECTED_GROUP:
      return Object.assign({}, state, {
        selectedGroup: action.data,
      });

    case REQUEST_ADD_UNIT_GROUP:
      return Object.assign({}, state, {
        addUnitGroupDataState: states.REQUEST,
      });
    case RESPONSE_ADD_UNIT_GROUP:
      const selectedGroup = state.selectedGroup;
      selectedGroup.units.push(action.data);

      return Object.assign({}, state, {
        addUnitGroupDataState: states.READY,
        selectedGroup: selectedGroup,
        companyGroups: state.companyGroups.map((x) => {
          if (x.id === selectedGroup.id) {
            return selectedGroup;
          }

          return x;
        }),
      });
    case REQUEST_ADD_UNIT_GROUP_FAILURE:
      return Object.assign({}, state, {
        addUnitGroupDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_DEL_UNIT_GROUP:
      return Object.assign({}, state, {
        delUnitGroupDataState: states.REQUEST,
      });
    case RESPONSE_DEL_UNIT_GROUP:
      const selectedGroupWithDelUnit = state.selectedGroup;

      selectedGroupWithDelUnit.units = selectedGroupWithDelUnit.units.filter((x) => {
        return x.id !== action.data.id;
      });

      return Object.assign({}, state, {
        delUnitGroupDataState: states.READY,
        selectedGroup: selectedGroupWithDelUnit,
        companyGroups: state.companyGroups.map((x) => {
          if (x.id === selectedGroup.id) {
            return selectedGroup;
          }

          return x;
        }),
      });
    case REQUEST_DEL_UNIT_GROUP_FAILURE:
      return Object.assign({}, state, {
        delUnitGroupDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_CREATE_GROUP:
      return Object.assign({}, state, {
        createGroupDataState: states.REQUEST,
      });
    case RESPONSE_CREATE_GROUP:
      return Object.assign({}, state, {
        createGroupDataState: states.READY,
        companyGroups: [action.data].concat(state.companyGroups),
      });
    case REQUEST_CREATE_GROUP_FAILURE:
      return Object.assign({}, state, {
        createGroupDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_DELETE_GROUP:
      return Object.assign({}, state, {
        createGroupDataState: states.REQUEST,
      });
    case RESPONSE_DELETE_GROUP:
      return Object.assign({}, state, {
        createGroupDataState: states.READY,
        companyGroups: state.companyGroups.filter((x) => {
          return x.id !== action.data.groupId;
        }),
      });
    case REQUEST_DELETE_GROUP_FAILURE:
      return Object.assign({}, state, {
        createGroupDataState: states.FAILURE,
        errors: action.errors,
      });

    default:
      return state;
  }
};

export default companyGroupsReducer;
